import { FormatCfopHelper } from "../../../helpers";
import { getOrigem } from "../../nf-entrada/list-nf-entrada/nf-entrada-xml";
const cfopHelper = new FormatCfopHelper();

export class FormatXmlProdutos {
  constructor(
    itens,
    fornecedorId,
    listaNcm,
    listaCfops,
    listaUnidadesComerciais,
    origensMercadoriasList,
    nfEntradaDto,
  ) {
    const cfopTemp =
      listaCfops.length &&
      !nfEntradaDto?.usoConsumo &&
      listaCfops.find(
        ({ codigo }) => codigo == cfopHelper.contraPartida(itens.CFOP),
      );
    const ncmTemp = listaNcm.find(({ codigo }) => codigo == itens.NCM);
    const unidade =
      listaUnidadesComerciais.find(
        (unidadeComercial) =>
          unidadeComercial.codigo.toLowerCase() === itens.uCom.toLowerCase(),
      ) ||
      listaUnidadesComerciais.find((unidadeComercial) =>
        unidadeComercial.codigo
          .toLowerCase()
          .includes(itens.uCom.toLowerCase()),
      ) ||
      listaUnidadesComerciais.find(
        (unidadeComercial) => unidadeComercial.codigo === "UN",
      );
    const origemNacionalId = origensMercadoriasList.find(
      (origem) => origem.codigo == 0,
    )?.id;
    this.tipo = "simples";
    this.ordem = itens.nItem;
    this.codigoBarra =
      itens.cEAN === "SEM GTIN" || typeof itens.cEAN === "object"
        ? null
        : itens.cEAN;
    this.cfop = cfopTemp ? cfopHelper.contraPartida(itens.CFOP) : "";
    this.cfopId = cfopTemp?.id ? cfopTemp.id : null;
    this.produto = itens.xProd.substring(0, 50);
    this.descricao = itens.xProd.substring(0, 50);
    this.fornecedorId = fornecedorId;
    this.unidadeComercialCompraId = unidade?.id ? unidade.id : null;
    this.unidadeComercialVendaId = unidade?.id ? unidade.id : null;
    this.unidade = unidade?.codigo ? unidade.codigo : null;
    this.codigoProduto = itens.cProd;
    this.quantidadeCompra = parseFloat(String(itens.qCom).replace(",", "."));
    this.quantidadeEmbalagem = parseFloat(String(itens.qCom).replace(",", "."));
    this.quantidade = parseFloat(String(itens.qCom).replace(",", "."));
    this.precoCompra = parseFloat(itens.vUnCom).toFixed(2);
    this.precoCusto = parseFloat(itens.vUnCom).toFixed(2);
    this.precoVenda = parseFloat(itens.vUnCom).toFixed(2);
    this.desconto = itens.vDesc ? parseFloat(itens.vDesc).toFixed(2) : 0;
    this.despesas = itens.vOutro ? parseFloat(itens.vOutro).toFixed(2) : 0;
    this.subtotal = parseFloat(itens.vProd);
    this.origemMercadoriaId =
      getOrigem(itens.ICMS, origensMercadoriasList)?.id || origemNacionalId;
    this.tributosIcmsOrigem =
      getOrigem(itens.ICMS, origensMercadoriasList)?.id || origemNacionalId;
    this.ncmCodigo = ncmTemp?.codigo;
    this.ncm = ncmTemp?.codigo;
    this.ncmId = ncmTemp?.id;
    this.informacaoAdicionalNfe = itens.informacaoAdicionalNfe;
    this.tributosIcmsAliquota = itens?.ICMS?.pICMS
      ? parseFloat(itens.ICMS.pICMS)
      : 0;
    this.tributosValorIcmsAliquota = itens?.ICMS?.vICMS
      ? parseFloat(itens.ICMS.vICMS)
      : 0;
    this.impostoIcmsStAliquota = itens?.ICMS?.pICMSST
      ? parseFloat(itens.ICMS.pICMSST)
      : 0;
    this.impostoValorIcmsStAliquota = itens?.ICMS?.vICMSST
      ? parseFloat(itens.ICMS.vICMSST)
      : 0;
    this.tributosIpiAliquota = itens?.IPI?.pIPI
      ? parseFloat(itens.IPI.pIPI)
      : 0;
    this.tributosValorIpiAliquota = itens?.IPI?.vIPI
      ? parseFloat(itens.IPI.vIPI)
      : 0;
    this.tributosIcmsModalidade = itens?.ICMS?.modBC;
    this.tributosIcmsCodigo = itens?.ICMS?.CST;
    this.tributosIcmsBcParcial = itens?.ICMS?.vBC
      ? parseFloat(itens.ICMS.vBC) / this.quantidade
      : 0;
    this.impostoIcmsStBcParcial = itens?.ICMS?.vBCST
      ? parseFloat(itens.ICMS.vBCST) / this.quantidade
      : 0;
    this.tributosIpiCodigo = itens?.IPI?.CST;
    this.tributosIpiBcParcial = itens?.IPI?.vBC
      ? parseFloat(itens.IPI.vBC) / this.quantidade
      : 0;
    this.tributosPisCodigo = itens?.PIS?.CST;
    this.tributosPisBcParcial = itens?.PIS?.vBC
      ? parseFloat(itens.PIS.vBC) / this.quantidade
      : 0;
    this.tributosPisAliquota = itens?.PIS?.pPIS
      ? parseFloat(itens.PIS.pPIS)
      : 0;
    this.tributosValorPisAliquota = itens?.PIS?.vPIS
      ? parseFloat(itens.PIS.vPIS)
      : 0;
    this.tributosCofinsCodigo = itens?.COFINS?.CST;
    this.tributosCofinsBcParcial = itens?.COFINS?.vBC
      ? parseFloat(itens.COFINS.vBC) / this.quantidade
      : 0;
    this.tributosCofinsAliquota = itens?.COFINS?.pCOFINS
      ? parseFloat(itens.COFINS.pCOFINS)
      : 0;
    this.tributosValorCofinsAliquota = itens?.COFINS?.vCOFINS
      ? parseFloat(itens.COFINS.vCOFINS)
      : 0;
    this.tributosIbsCst = itens?.IBSCBS?.CST;
    this.tributosIbsClassificacao = itens?.IBSCBS?.cClassTrib;
    this.tributosIbsBcParcial = itens?.IBSCBS?.vBC
      ? parseFloat(itens.IBSCBS.vBC) / this.quantidade
      : 0;
    this.tributosIbsAliquotaUf = itens?.IBSCBS?.gIBSUF?.pIBSUF
      ? parseFloat(itens.IBSCBS.gIBSUF.pIBSUF)
      : 0;
    this.tributosIbsAliquotaMun = itens?.IBSCBS?.gIBSMun?.pIBSMun
      ? parseFloat(itens.IBSCBS.gIBSMun.pIBSMun)
      : 0;
    this.tributosIbsAliquotaCbs = itens?.IBSCBS?.gCBS?.pCBS
      ? parseFloat(itens.IBSCBS.gCBS.pCBS)
      : 0;
    this.tributosIbsAliquotaRedUf = itens?.IBSCBS?.gIBSUF?.gRed?.pRedAliq
      ? parseFloat(itens.IBSCBS.gIBSUF.gRed.pRedAliq)
      : 0;
    this.tributosIbsAliquotaRedMun = itens?.IBSCBS?.gIBSMun?.gRed?.pRedAliq
      ? parseFloat(itens.IBSCBS.gIBSMun.gRed.pRedAliq)
      : 0;
    this.tributosIbsAliquotaRedCbs = itens?.IBSCBS?.gCBS?.gRed?.pRedAliq
      ? parseFloat(itens.IBSCBS.gCBS.gRed.pRedAliq)
      : 0;
    const credPresIbs = itens?.IBSCBS?.gCredPresOper?.gIBSCredPres;
    const credPresCbs = itens?.IBSCBS?.gCredPresOper?.gCBSCredPres;
    this.codigoCredPresIbs = itens?.IBSCBS?.gCredPresOper?.cCredPres;
    this.tributosIbsAliquotaCredPres = credPresIbs?.pCredPres
      ? parseFloat(credPresIbs.pCredPres)
      : null;
    this.tributosCbsAliquotaCredPres = credPresCbs?.pCredPres
      ? parseFloat(credPresCbs.pCredPres)
      : null;
    this.credPresCondSusIbs = credPresIbs?.vCredPresCondSus != null;
    this.credPresCondSusCbs = credPresCbs?.vCredPresCondSus != null;
    this.aliquotaMva = itens?.ICMS?.pMVAST ? parseFloat(itens.ICMS.pMVAST) : 0;
    this.valorFrete = itens?.vFrete ? parseFloat(itens.vFrete) : null;
    this.isMedicamento = !!itens?.med;
    this.isCombustivel = !!itens?.comb;
    this.dataValidade = itens.rastro?.dVal ? new Date(itens.rastro.dVal) : null;
    this.dataFabricacao = itens.rastro?.dFab
      ? new Date(itens.rastro.dFab)
      : null;
    this.precoMaxConsumo =
      itens.med?.vPMC != null && itens.med.vPMC !== ""
        ? parseFloat(itens.med.vPMC)
        : null;
    this.numLote = itens.rastro?.nLote ?? null;
    this.qtdLote =
      itens.rastro?.qLote != null && itens.rastro.qLote !== ""
        ? parseFloat(itens.rastro.qLote)
        : null;
    this.agregado = itens.rastro?.cAgreg ?? null;
    this.prodAnvisa = itens.med?.cProdANVISA ?? null;
    this.motivoIsencao = itens.IPI?.cEnq ?? null;

    this.anpCodigo = itens.comb?.cProdANP ?? null;
    this.anpDescricao = itens.comb?.descANP ?? null;
    this.glp =
      itens.comb?.pGLP != null && itens.comb.pGLP !== ""
        ? parseFloat(itens.comb.pGLP)
        : null;
    this.gasNaturalNacional =
      itens.comb?.pGNN != null && itens.comb.pGNN !== ""
        ? parseFloat(itens.comb.pGNN)
        : null;
    this.gasNaturalImp =
      itens.comb?.pGNI != null && itens.comb.pGNI !== ""
        ? parseFloat(itens.comb.pGNI)
        : null;
    this.valorPartida =
      itens.comb?.vPart != null && itens.comb.vPart !== ""
        ? parseFloat(itens.comb.vPart)
        : null;
    this.codif = itens.comb?.CODIF ?? null;
    this.qtdCombTempAmbiente =
      itens.comb?.qTemp != null && itens.comb.qTemp !== ""
        ? parseFloat(itens.comb.qTemp)
        : null;

    this.bcCide =
      itens.comb?.CIDE?.qBCProd != null && itens.comb.CIDE.qBCProd !== ""
        ? parseFloat(itens.comb.CIDE.qBCProd)
        : null;
    this.aliquotaCide =
      itens.comb?.CIDE?.vAliqProd != null && itens.comb.CIDE.vAliqProd !== ""
        ? parseFloat(itens.comb.CIDE.vAliqProd)
        : null;
    this.valorCide =
      itens.comb?.CIDE?.vCIDE != null && itens.comb.CIDE.vCIDE !== ""
        ? parseFloat(itens.comb.CIDE.vCIDE)
        : null;

    this.indicadorImportacao = itens.comb?.indImportado ?? null;
    this.ufOrigem = itens.comb?.UFCons ?? null;
    this.percentualUf =
      itens.comb?.pBCOp != null && itens.comb.pBCOp !== ""
        ? parseFloat(itens.comb.pBCOp)
        : null;
  }
}
